"use client";
import React from "react";
// import { CompanyInfo } from "../../../../types";
import { Config } from "src/types";
// import { getSocialIcons } from "./NavBar";
import Link from "next/link";
import { FOOTER_NAV_LINKS } from "../../constants/navlink";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";
import { useFetchValidSocialMediaLinks } from "src/app/lib/useFetcchValidSocialMediaLinks";
import { usePagesWithBranchQuery } from "src/app/hooks/useBranchFirst";
import { stripQueryParams } from "../../utils";
import { capitalize } from "lodash";

export function getPageVisibilityClass(
  url: string,
  config: Config,
  style?: string
): string {
  const settings = config?.websiteSettings;
  if (!settings) return "";
  const visibilityMap: Record<string, keyof typeof settings> = {
    "/about": "about_us_display",
    "/contact": "services_contact_page",
    "/branches": "staffs_branch_options",
    "/properties/sale": "sale_properties",
    "/properties": "modules_listing",
    "/properties/rent": "rent_properties",
    "/properties/shortlet": "shortlet_properties",
  };
  const key = visibilityMap[stripQueryParams(url)];

  // If config says the section should not be visible, return Tailwind's hidden class
  if (key && settings[key] === false) {

    return style || "!text-disabled-main pointer-events-none hidden";
  }
  return ""; // Show by default
}

const Footer1 = () => {
  const { data } = useFetchCompanyInfo();
  const { socialMediaLinks } = useFetchValidSocialMediaLinks();
  const alteredLinks = usePagesWithBranchQuery();
  return (
    <footer className="bg-white w-full">
      <div
        style={{
          backgroundImage: `linear-gradient(180.79deg, rgba(var(--primary-color-rgb), 0.6) 12.91%, rgba(var(--primary-color-rgb), 0.8) 41.45%, var(--primary-color) 58.98%), url('/images/bg-footer-1.webp')`,
          backgroundSize: "contain",
        }}
        className="py-14 pb-[8rem] text-white"
      >
        <div className="wrapper font-semibold ">
          <div className="first ml-[8%] xl:ml-0 md:flex-col md:gap-10 flex gap-[10%]">
            <div className="first flex flex-col gap-2 w-max">
              <FooterHeader>Contact</FooterHeader>
              {data?.companyInfo?.phone_number &&
                Array.isArray(data?.companyInfo?.phone_number) && (
                  <Flex icon={<CallIcon />}>
                    <div className="grid gap-[6px] grid-cols-2">
                      {Array.isArray(data?.companyInfo?.phone_number) ? (
                        data.companyInfo.phone_number.map((item, index) => (
                          <Link
                            key={index}
                            href={`tel:${item}`}
                            className="hover:underline font-thin"
                            aria-label={`Call ${item}`}
                          >
                            {item}
                          </Link>
                        ))
                      ) : (
                        <p>No phone numbers available</p>
                      )}
                    </div>
                  </Flex>
                )}

              {data?.companyInfo?.head_office_address && (
                <Flex icon={<LocationIcon />}>
                  {data?.companyInfo?.head_office_address ? (
                    <Link
                      href={`https://maps.google.com/?q=${encodeURIComponent(
                        data?.companyInfo?.head_office_address
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <address className="font-thin max-w-[250px] ">
                        {capitalize(data?.companyInfo?.head_office_address)}
                      </address>
                    </Link>
                  ) : (
                    <span>No Address Available</span>
                  )}
                </Flex>
              )}

              {data?.companyInfo?.email && (
                <Flex icon={<MessageIcon />}>
                  {data?.companyInfo?.email ? (
                    <Link
                      className="font-thin"
                      href={`mailto:${data?.companyInfo?.email}`}
                    >
                      <span>{data?.companyInfo?.email}</span>
                    </Link>
                  ) : (
                    <span>No Address Available</span>
                  )}
                </Flex>
              )}
            </div>
            <div className="second">
              <FooterHeader>Products</FooterHeader>
              <LinkWithIcon config={data} items={FOOTER_NAV_LINKS} />
            </div>
            <div className="third">
              <FooterHeader>Pages</FooterHeader>
              <LinkWithIcon config={data} items={alteredLinks} />
            </div>
          </div>
        </div>
      </div>
      <div className="second text-themeColor items-center py-3 flex md:flex-col md:gap-5 justify-between wrapper z-[10] bg-white">
        <div className="second items-center flex gap-2">
          {socialMediaLinks?.map((item, index) => {
            return (
              <Link href={item.url} key={index}>
                {item.icon}
              </Link>
            );
          })}
        </div>
        <p
          className="truncate overflow-hidden whitespace-nowrap mx-4 md:mx-auto  xs:max-w-full "
          title={`${data?.companyInfo?.name}. All Rights Reserved.`}
        >
          © {data?.companyInfo?.name}. All Rights Reserved.
        </p>

        {data?.websiteSettings?.sponsored_logo && (
          <Link
            target={"_blank"}
            href="https://ourproperty.com.ng/"
            className="p flex items-center text-[10px]"
          >
            <span className="inline-block text-[13px] mr-2">Powered By:</span>
            <LogoVariant />
            <div className="font-bold ml-1">Our Property NG</div>
          </Link>
        )}
      </div>
    </footer>
  );
};

export const LogoVariant = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 48 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3498_88799"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="46"
      >
        <path d="M48 0H0V46H48V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_3498_88799)">
        <path
          d="M27.0042 1.23206C27.7783 1.68739 28.5606 2.12866 29.3445 2.56809C29.5521 2.6845 29.7593 2.80127 29.9665 2.91818C30.3399 3.12875 30.7139 3.33828 31.0885 3.54685C31.1479 3.57993 31.2073 3.613 31.2685 3.64709C31.9936 4.04948 32.7264 4.43619 33.4687 4.80848C33.5406 4.84471 33.6125 4.88094 33.6866 4.91828C34.2966 5.24799 34.2966 5.24799 34.9666 5.38195C34.9656 5.31161 34.9656 5.31161 34.9646 5.23984C34.962 5.02724 34.9604 4.81464 34.9587 4.60203C34.9576 4.52822 34.9565 4.45442 34.9555 4.37838C34.9549 4.27193 34.9549 4.27193 34.9542 4.16333C34.9532 4.06531 34.9532 4.06531 34.9522 3.9653C34.9759 3.68083 34.9759 3.68083 35.0938 3.54685C35.384 3.48311 35.6755 3.47541 35.9724 3.46632C36.0134 3.46505 36.0545 3.46377 36.0967 3.46246C36.2313 3.45842 36.3658 3.45481 36.5004 3.45127C36.5467 3.44997 36.593 3.44867 36.6407 3.44734C37.7779 3.41597 38.9152 3.41843 40.0527 3.42451C40.1269 3.9875 40.1245 4.54662 40.1225 5.1129C40.1224 5.21626 40.1223 5.31961 40.1222 5.42297C40.122 5.69307 40.1214 5.96317 40.1207 6.23326C40.12 6.50969 40.1197 6.78606 40.1194 7.06249C40.1187 7.60336 40.1177 8.14422 40.1163 8.68515C40.1911 8.71378 40.1911 8.71378 40.2674 8.74302C41.1087 9.06832 41.9064 9.48948 42.6983 9.91119C42.9572 10.0488 43.2182 10.1814 43.4813 10.3115C44.3309 10.7323 45.1481 11.2066 45.9653 11.6825C46.0228 11.716 46.0228 11.716 46.0814 11.7501C46.3478 11.9053 46.6136 12.0613 46.8792 12.2177C46.9487 12.2585 47.0182 12.2993 47.0899 12.3414C47.1869 12.3989 47.1869 12.3989 47.286 12.4576C47.3427 12.4911 47.3993 12.5246 47.4577 12.5591C47.5107 12.5928 47.5637 12.6265 47.6183 12.6612C47.6732 12.6924 47.7282 12.7236 47.7848 12.7557C47.9748 12.9441 47.9741 13.04 47.9778 13.2939C47.9766 13.3726 47.9766 13.3726 47.9753 13.4528C47.9757 13.509 47.976 13.5652 47.9764 13.6231C47.9773 13.8126 47.9759 14.0021 47.9744 14.1916C47.9746 14.328 47.9748 14.4644 47.9752 14.6008C47.9759 14.9774 47.9746 15.354 47.9731 15.7306C47.9718 16.1 47.9721 16.4692 47.9723 16.8386C47.9727 17.5898 47.9717 18.341 47.9698 19.0922C47.9671 20.108 47.9665 21.1237 47.9663 22.1395C47.9646 24.5823 47.9602 27.025 47.956 29.4677C47.9495 34.923 47.9429 40.3784 47.9362 45.999C32.5787 45.999 17.2213 45.999 1.39844 45.999C1.39844 44.3639 1.39844 42.7288 1.39844 41.0442C4.1266 41.0373 4.1266 41.0373 5.09264 41.0348C5.18817 41.0347 5.18817 41.0347 5.28564 41.0344C8.05562 41.0274 10.8256 41.0208 13.5956 41.0142C13.8269 41.0136 14.0582 41.0131 14.2895 41.0125C27.5911 40.9808 27.5911 40.9808 33.1577 40.9789C33.2437 40.9789 33.3298 40.9789 33.4157 40.9789C36.5605 40.9778 39.7053 40.9806 42.8501 40.983C42.8748 37.7828 42.8939 34.5827 42.9053 31.3824C42.9066 31.0047 42.908 30.6269 42.9095 30.2491C42.9097 30.1739 42.91 30.0987 42.9103 30.0212C42.915 28.8032 42.9235 27.5854 42.9335 26.3675C42.9436 25.1179 42.9496 23.8683 42.9517 22.6186C42.9533 21.8475 42.958 21.0764 42.9668 20.3053C42.9724 19.7765 42.9742 19.2478 42.9728 18.7191C42.9721 18.4139 42.9731 18.109 42.9789 17.8039C43.062 16.6743 43.062 16.6743 42.7451 15.6259C42.4981 15.3983 42.2309 15.2896 41.9035 15.2074C41.692 15.1471 41.5239 15.0416 41.3369 14.9298C41.199 14.854 41.061 14.7784 40.923 14.7028C40.8468 14.661 40.7707 14.6192 40.6946 14.5774C40.5376 14.4912 40.3805 14.4051 40.2235 14.319C39.8459 14.1119 39.4685 13.9047 39.0912 13.6973C39.0543 13.6771 39.0175 13.6568 38.9796 13.636C38.2387 13.2287 37.4995 12.8187 36.7606 12.4079C36.486 12.2552 36.2112 12.1027 35.9364 11.9502C35.7299 11.8356 35.5233 11.7209 35.3168 11.6063C35.0397 11.4524 34.7626 11.2987 34.4854 11.1451C33.8209 10.7767 33.1571 10.4073 32.4951 10.0347C31.9058 9.70308 31.3137 9.37613 30.7205 9.05101C30.204 8.76791 29.6898 8.48151 29.1773 8.19194C28.5713 7.84993 27.959 7.52029 27.3437 7.19413C26.9189 6.96829 26.4983 6.737 26.0805 6.49954C24.8483 5.72788 24.8483 5.72788 23.4355 5.66104C22.8791 5.84914 22.3716 6.18916 21.87 6.48302C21.7742 6.53905 21.7742 6.53905 21.6766 6.59619C21.5352 6.67901 21.3937 6.76184 21.2523 6.8446C21.2155 6.86619 21.1787 6.88772 21.1407 6.90993C21.0649 6.95434 20.989 6.99881 20.9132 7.04328C20.3349 7.38229 19.753 7.71475 19.168 8.04286C18.5974 8.36284 18.03 8.68692 17.4664 9.01798C16.845 9.38286 16.2228 9.74639 15.5967 10.1036C15.5181 10.1486 15.4395 10.1939 15.361 10.2392C14.6304 10.662 13.9681 10.9978 13.0964 10.8873C12.5481 10.7552 12.0875 10.4389 11.6204 10.145C11.2129 9.89155 10.7922 9.67782 10.3587 9.46886C9.77835 9.18693 9.26948 8.91191 8.90042 8.3793C8.90042 8.31874 8.90042 8.25818 8.90042 8.19579C9.03088 8.10465 9.15676 8.028 9.29631 7.9516C9.33764 7.92823 9.37896 7.90486 9.42156 7.88076C9.55742 7.80418 9.69379 7.72857 9.83022 7.6529C9.92451 7.59999 10.0187 7.54696 10.1129 7.49392C10.3008 7.38822 10.4888 7.28282 10.6771 7.17773C11.0013 6.99661 11.3238 6.81249 11.6462 6.6283C12.9336 5.89613 14.2253 5.1707 15.5175 4.44615C15.7698 4.3046 16.0222 4.16297 16.2746 4.02133C16.402 3.94976 16.5296 3.8782 16.6571 3.80664C16.9734 3.62912 17.2897 3.45152 17.6059 3.27373C18.1906 2.94506 18.7758 2.61724 19.3629 2.29239C20.4341 1.69958 21.4996 1.09739 22.5568 0.481615C24.3147 -0.54152 25.4021 0.289259 27.0042 1.23206Z"
          fill="var(--primary-color)"
        />
        <path
          d="M12.9629 24.3805C13.2967 24.5962 13.5809 24.9157 13.7033 25.2887C13.8368 26.0574 13.6919 26.8421 13.5495 27.5989C13.5309 27.7018 13.5124 27.8047 13.4939 27.9077C13.4458 28.1754 13.3966 28.443 13.3472 28.7105C13.2678 29.1403 13.1898 29.5704 13.1123 30.0005C13.0852 30.1496 13.0575 30.2985 13.0299 30.4474C13.0131 30.5392 12.9964 30.631 12.9797 30.7228C12.965 30.8023 12.9503 30.8818 12.9352 30.9636C12.9015 31.212 12.8893 31.4336 12.9038 31.6836C13.0348 31.8527 13.0348 31.8527 13.2217 31.9895C13.2868 32.0475 13.3514 32.106 13.4157 32.1649C13.4847 32.2263 13.5539 32.2876 13.623 32.3489C13.6597 32.3815 13.6964 32.414 13.7342 32.4476C13.9209 32.6129 14.1092 32.7756 14.3025 32.9338C14.5397 33.1323 14.7654 33.3415 14.9899 33.5532C15.0258 33.5863 15.0616 33.6196 15.0986 33.6538C15.4489 33.988 15.5974 34.314 15.6694 34.7842C15.6771 34.8324 15.6847 34.8806 15.6926 34.9303C15.8243 35.8205 15.8851 36.721 15.9555 37.6172C15.9626 37.7076 15.9626 37.7076 15.97 37.7998C15.9932 38.1058 16.01 38.4116 16.019 38.7182C16.0208 38.7736 16.0225 38.8291 16.0243 38.8861C16.0293 39.0685 16.0324 39.2508 16.0349 39.4332C16.037 39.5178 16.037 39.5178 16.0391 39.6041C16.0412 40.0106 15.9958 40.3108 15.7052 40.6255C15.6619 40.6597 15.6186 40.694 15.574 40.7292C15.5308 40.7644 15.4875 40.7995 15.4429 40.8357C15.1144 41.0613 14.6872 41.0057 14.3025 40.9815C13.9498 40.8766 13.7257 40.6707 13.5396 40.3698C13.1959 39.4967 13.2216 38.5446 13.186 37.6248C13.1765 37.3889 13.1669 37.1531 13.1561 36.9173C13.1495 36.7716 13.1437 36.626 13.1387 36.4802C13.1103 35.8461 13.022 35.3078 12.5223 34.8645C12.3583 34.7293 12.1914 34.5983 12.0227 34.4685C11.5247 34.0856 11.0294 33.6906 10.5878 33.2475C10.4753 33.1396 10.3557 33.0433 10.2336 32.9453C9.74782 32.5397 9.45931 32.1511 9.37908 31.5262C9.34093 30.7268 9.5131 29.963 9.68265 29.1853C9.70262 29.0938 9.72252 29.0024 9.74242 28.9109C9.75208 28.8666 9.76174 28.8223 9.77166 28.7767C9.86442 28.3414 9.92583 27.9042 9.9793 27.4629C9.44825 27.6854 9.19426 27.9527 8.96577 28.4578C8.83474 28.7839 8.74402 29.1217 8.64821 29.4586C8.6037 29.6112 8.55914 29.7638 8.51438 29.9164C8.48234 30.0255 8.48234 30.0255 8.44966 30.1368C8.37559 30.3862 8.29847 30.6342 8.21506 30.8808C8.19313 30.9462 8.17119 31.0117 8.14856 31.0791C8.03317 31.3451 7.92255 31.5638 7.65833 31.7118C7.6034 31.7303 7.54847 31.7487 7.49188 31.7678C7.4367 31.7871 7.38145 31.8065 7.32455 31.8265C7.18195 31.8672 7.18195 31.8672 7.0548 31.8672C7.0478 31.9008 7.04075 31.9344 7.0335 31.969C6.96013 32.3048 6.86261 32.623 6.74238 32.9458C6.71511 33.0205 6.71511 33.0205 6.6872 33.0966C6.64785 33.2042 6.6083 33.3116 6.56869 33.419C6.46068 33.7117 6.35388 34.0047 6.24696 34.2977C6.22463 34.3589 6.20229 34.42 6.17926 34.483C5.9522 35.1057 5.73083 35.7303 5.51042 36.3552C5.4458 36.5384 5.38107 36.7215 5.31629 36.9046C5.14674 37.3842 4.97726 37.8637 4.80983 38.344C4.76628 38.4687 4.7225 38.5934 4.67862 38.718C4.62825 38.8612 4.57827 39.0046 4.52884 39.1481C4.10331 40.3523 4.10331 40.3523 3.81245 40.4922C3.78134 40.4093 3.78134 40.4093 3.74961 40.3247C3.72183 40.2525 3.69405 40.1804 3.66543 40.106C3.63813 40.0344 3.61085 39.9627 3.58273 39.8888C3.50368 39.7168 3.45698 39.6248 3.30384 39.5134C2.98475 39.3954 2.74502 39.3637 2.41377 39.4523C2.1904 39.6322 2.02257 39.8455 1.84158 40.064C0.466676 39.8015 0.466676 39.8015 0.148483 39.4649C-0.0228404 39.1992 0.0255447 38.8748 0.0935396 38.5784C0.137731 38.4383 0.187811 38.3019 0.241004 38.1648C0.259942 38.1136 0.278882 38.0624 0.298395 38.0095C0.360239 37.8428 0.42343 37.6764 0.486616 37.5101C0.530009 37.3936 0.573286 37.2772 0.616454 37.1606C0.682865 36.9814 0.749353 36.8022 0.816216 36.6232C1.023 36.0694 1.22225 35.5132 1.41933 34.9561C1.47066 34.8111 1.52214 34.6661 1.57367 34.5211C1.60561 34.4311 1.63755 34.3411 1.66948 34.2511C1.68453 34.2088 1.69957 34.1664 1.71507 34.1228C1.82689 33.8072 1.93472 33.4904 2.04006 33.1727C2.12512 32.9544 2.20599 32.8452 2.41377 32.7235C2.86303 32.6666 3.24178 32.7602 3.65748 32.9147C3.71173 32.9338 3.76598 32.953 3.82188 32.9728C3.93355 33.0123 4.04506 33.0521 4.15643 33.0923C4.4118 33.1845 4.66828 33.2735 4.92503 33.362C4.96949 33.3778 5.01396 33.3937 5.05977 33.4099C5.27447 33.4845 5.42435 33.5188 5.65615 33.5188C5.73839 33.2905 5.81984 33.062 5.90062 32.8333C5.94165 32.7175 5.9833 32.6021 6.02495 32.4865C6.05076 32.4132 6.07658 32.3398 6.10317 32.2643C6.12714 32.197 6.15111 32.1298 6.17581 32.0605C6.22994 31.8613 6.25262 31.7047 6.22834 31.5001C6.13393 31.4396 6.13393 31.4396 6.03761 31.3778C5.898 30.9748 5.98424 30.5719 6.08529 30.1697C6.09848 30.1167 6.11168 30.0637 6.12528 30.0091C6.27871 29.4257 6.47581 28.8556 6.67334 28.2849C6.68968 28.2376 6.70602 28.1903 6.72287 28.1415C7.21787 26.7133 7.65807 26.1405 9.05579 25.4421C9.36852 25.2855 9.67636 25.1228 9.98216 24.954C10.8464 24.4783 11.9783 23.8983 12.9629 24.3805Z"
          fill="#010C48"
        />
        <path
          d="M23.1148 15.3442C23.1793 15.3442 23.2438 15.3441 23.3103 15.3441C23.4468 15.3441 23.5833 15.3442 23.7198 15.3444C23.9249 15.3447 24.1302 15.3444 24.3354 15.344C24.9321 15.3438 25.5278 15.3472 26.1237 15.3796C26.1682 15.382 26.2126 15.3844 26.2584 15.3868C26.5577 15.4056 26.5577 15.4056 26.7014 15.4747C26.7948 15.8225 26.7793 16.1894 26.785 16.5464C26.7864 16.6155 26.7877 16.6847 26.789 16.756C26.7918 16.9029 26.7944 17.0498 26.7969 17.1967C26.8006 17.4159 26.8047 17.6351 26.809 17.8543C26.8116 17.9982 26.8142 18.1421 26.8168 18.2859C26.818 18.3491 26.8192 18.4124 26.8205 18.4774C26.8325 19.2099 26.8285 19.9414 26.8285 20.6742C25.0452 20.6742 23.2619 20.6742 21.4246 20.6742C21.2066 19.8354 21.2896 18.8892 21.2861 18.0283C21.2857 17.9174 21.285 17.8066 21.2841 17.6957C21.2718 15.9971 21.2718 15.9971 21.6153 15.5359C22.0861 15.33 22.6076 15.3433 23.1148 15.3442Z"
          fill="var(--primary-color)"
        />
        <path
          d="M9.40698 33.0312C9.66783 33.1155 9.83091 33.2292 10.0308 33.4098C10.114 33.4839 10.114 33.4839 10.1989 33.5596C10.279 33.6311 10.279 33.6311 10.3606 33.7041C10.4451 33.7759 10.5298 33.8473 10.6149 33.9182C10.655 33.9521 10.6951 33.9861 10.7364 34.021C10.8367 34.105 10.938 34.188 11.0399 34.2704C11.0976 34.3182 11.1554 34.366 11.2149 34.4152C11.2954 34.4807 11.2954 34.4807 11.3776 34.5476C11.5276 34.7068 11.5477 34.7769 11.5686 34.9887C11.5267 35.1772 11.5267 35.1772 11.4553 35.3923C11.4423 35.4321 11.4293 35.4719 11.4159 35.5129C11.3722 35.6455 11.3274 35.7778 11.2825 35.91C11.2512 36.0038 11.2199 36.0975 11.1887 36.1912C11.0837 36.5045 10.9766 36.8171 10.8692 37.1297C10.8495 37.1872 10.8298 37.2446 10.8095 37.3038C10.6856 37.6649 10.5607 38.0256 10.4346 38.3859C10.3936 38.503 10.3528 38.6202 10.3121 38.7375C9.69816 40.5033 9.69816 40.5033 9.09431 40.8749C8.76372 40.993 8.33146 40.9782 7.99591 40.8823C7.68025 40.7237 7.40446 40.4332 7.24539 40.127C7.12485 39.3645 7.43828 38.6614 7.68642 37.9517C7.73207 37.8184 7.77752 37.6851 7.82292 37.5519C7.9186 37.2714 8.01498 36.9912 8.11187 36.711C8.2663 36.2637 8.41767 35.8155 8.56854 35.3672C8.66651 35.0766 8.76454 34.786 8.86258 34.4955C8.88635 34.425 8.91013 34.3545 8.93467 34.282C9.00175 34.0835 9.06907 33.8851 9.13653 33.6867C9.15662 33.6271 9.17671 33.5676 9.19737 33.5062C9.22496 33.4253 9.22496 33.4253 9.25313 33.3429C9.27709 33.2721 9.27709 33.2721 9.30157 33.2C9.3434 33.0924 9.3434 33.0924 9.40698 33.0312Z"
          fill="#010C48"
        />
        <path
          d="M13.9848 19.8596C14.5166 20.2044 14.8224 20.5657 14.9874 21.1701C15.1182 21.832 15.0573 22.418 14.6662 22.9869C14.3196 23.4009 13.8741 23.5971 13.3461 23.7135C12.678 23.7805 12.1222 23.673 11.5684 23.2918C11.1418 22.9309 10.904 22.4309 10.8464 21.8932C10.8241 21.3067 10.9363 20.8061 11.3275 20.3453C11.9749 19.6958 13.1286 19.4084 13.9848 19.8596Z"
          fill="#010C48"
        />
        <path
          d="M14.0454 27.2812C14.3522 27.311 14.5199 27.3847 14.7607 27.568C14.8265 27.6174 14.8924 27.6669 14.9603 27.7178C14.9966 27.7455 15.0329 27.7732 15.0702 27.8017C15.2503 27.9391 15.4318 28.0744 15.6133 28.2099C15.7127 28.2843 15.8119 28.3587 15.9112 28.4333C16.1872 28.6406 16.4654 28.844 16.7474 29.0437C17.7478 29.7649 17.7478 29.7649 17.86 30.2174C17.879 30.5827 17.7881 30.8522 17.5421 31.135C17.2589 31.3751 17.0814 31.4718 16.695 31.4647C16.078 31.3781 15.5785 30.9539 15.1106 30.5861C14.8076 30.3483 14.4922 30.1266 14.1768 29.9045C13.8615 29.68 13.8615 29.68 13.7911 29.5445C13.7577 29.0711 13.8145 28.6058 13.8825 28.1376C13.8954 28.0439 13.8954 28.0439 13.9085 27.9481C13.9726 27.4916 13.9726 27.4916 14.0454 27.2812Z"
          fill="#010C48"
        />
        <path
          d="M3.17357 39.6382C3.35991 39.776 3.41695 39.8513 3.49145 40.0664C3.52787 40.5008 3.52787 40.5008 3.37225 40.7354C3.13775 40.9544 2.94768 40.9429 2.63218 40.9407C2.41244 40.9157 2.30343 40.8332 2.15636 40.6781C2.08242 40.5358 2.08223 40.4464 2.08086 40.2881C2.07996 40.2409 2.07905 40.1938 2.07812 40.1452C2.09464 39.9874 2.1304 39.8933 2.21993 39.7605C2.56456 39.5682 2.78685 39.5467 3.17357 39.6382Z"
          fill="#010C48"
        />
      </g>
    </svg>
  );
};
export default Footer1;
export const Flex: React.FC<{
  icon: React.ReactNode;
  children: React.ReactNode;
}> = ({ icon, children }) => {
  return (
    <div className="flex gap-2 mb-1 w-max">
      <span>{icon}</span>
      <div className="flex flex-wrap">{children}</div>
    </div>
  );
};

const FooterHeader: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return <h4 className="mb-6 font-normal">{children}</h4>;
};

const CallIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.51497 2.5C7.93164 2.5 9.59831 6.25 9.59831 6.66667C9.59831 7.5 8.34831 8.33333 7.93164 9.16667C7.51497 10 8.34831 10.8333 9.18164 11.6667C9.50664 11.9917 10.8483 13.3333 11.6816 12.9167C12.515 12.5 13.3483 11.25 14.1816 11.25C14.5983 11.25 18.3483 12.9167 18.3483 13.3333C18.3483 15 17.0983 16.25 15.8483 16.6667C14.5983 17.0833 13.765 17.0833 12.0983 16.6667C10.4316 16.25 9.18164 15.8333 7.09831 13.75C5.01497 11.6667 4.59831 10.4167 4.18164 8.75C3.76497 7.08333 3.76497 6.25 4.18164 5C4.59831 3.75 5.84831 2.5 7.51497 2.5Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const LocationIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8477 10.8335C12.2284 10.8335 13.3477 9.71421 13.3477 8.3335C13.3477 6.95278 12.2284 5.8335 10.8477 5.8335C9.46694 5.8335 8.34766 6.95278 8.34766 8.3335C8.34766 9.71421 9.46694 10.8335 10.8477 10.8335Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8483 1.66675C9.0802 1.66675 7.3845 2.36913 6.13426 3.61937C4.88402 4.86961 4.18164 6.5653 4.18164 8.33341C4.18164 9.91008 4.51664 10.9417 5.43164 12.0834L10.8483 18.3334L16.265 12.0834C17.18 10.9417 17.515 9.91008 17.515 8.33341C17.515 6.5653 16.8126 4.86961 15.5624 3.61937C14.3121 2.36913 12.6164 1.66675 10.8483 1.66675Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const MessageIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.68099 7.50008L9.80599 10.0001C10.1016 10.2368 10.469 10.3657 10.8477 10.3657C11.2263 10.3657 11.5937 10.2368 11.8893 10.0001L15.0143 7.50008M18.3477 14.1667V5.83341C18.3477 5.39139 18.1721 4.96746 17.8595 4.6549C17.5469 4.34234 17.123 4.16675 16.681 4.16675H5.01432C4.5723 4.16675 4.14837 4.34234 3.83581 4.6549C3.52325 4.96746 3.34766 5.39139 3.34766 5.83341V14.1667C3.34766 14.6088 3.52325 15.0327 3.83581 15.3453C4.14837 15.6578 4.5723 15.8334 5.01432 15.8334H16.681C17.123 15.8334 17.5469 15.6578 17.8595 15.3453C18.1721 15.0327 18.3477 14.6088 18.3477 14.1667Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const LinkWithIcon: React.FC<{
  items: { url: string; name: string }[];
  config?: Config;
}> = ({ items, config }) => {
  return (
    <ul className={"flex xs:text-[14px] text-[17px] flex-col gap-3"}>
      {items.map((item, index) => {
        return (
          <li
            className={` ${
              config && getPageVisibilityClass(item.url, config)
            } `}
            key={index}
          >
            <Link
              className={`flex font-thin items-center gap-2 `}
              href={item.url}
            >
              <svg
                width="8"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.01807 1.51176C0.963975 1.45451 0.921682 1.38716 0.89361 1.31357C0.865537 1.23997 0.852234 1.16157 0.854461 1.08284C0.856688 1.0041 0.874402 0.926576 0.90659 0.854687C0.938779 0.782798 0.984811 0.717952 1.04206 0.663853C1.09931 0.609754 1.16665 0.567461 1.24025 0.539388C1.31384 0.511315 1.39224 0.498013 1.47098 0.50024C1.54971 0.502467 1.62724 0.520181 1.69913 0.552369C1.77102 0.584557 1.83586 0.63059 1.88996 0.687839L6.98697 6.08467C7.09223 6.19601 7.15088 6.34341 7.15088 6.49663C7.15088 6.64985 7.09223 6.79725 6.98697 6.90859L1.88996 12.306C1.83622 12.3645 1.77139 12.4118 1.69924 12.445C1.62708 12.4782 1.54904 12.4968 1.46965 12.4996C1.39026 12.5024 1.3111 12.4895 1.23677 12.4614C1.16244 12.4334 1.09442 12.3909 1.03667 12.3363C0.978907 12.2818 0.932561 12.2163 0.900321 12.1437C0.86808 12.0711 0.850586 11.9928 0.848857 11.9134C0.847127 11.834 0.861196 11.755 0.890245 11.6811C0.919294 11.6071 0.962745 11.5397 1.01807 11.4827L5.72651 6.49663L1.01807 1.51176Z"
                  fill="currentColor"
                />
              </svg>
              <span>{item.name}</span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
